
define('ldsh!modules/editor/templates/editors/text', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container md__modal__v2">\n  <div class="modal-header">\n    <div class="close-wrapper">\n      <a class="js-close close">\n        <i class="ri-close-line" data-dismiss="modal"></i>\n      </a>\n    </div>\n    <h2 data-i18n="editor.editText"></h2>\n  </div>\n\n  <div class="modal-body modal__body--with-title-one-line">\n    <textarea id="ckeditor" style="display: none">\n      ' +
((__t = ( content )) == null ? '' : __t) +
'\n    </textarea>\n\n    <p class="italic f13"><span\n      data-i18n="editor.placeholderInstructions"></span><a\n      class="i18n" data-i18n="[href]editor.placeholderHelp" target="_blank"><span\n      class="i18n" data-i18n="editor.placeholderMoreInstructions"></span></a></p>\n    ';
 if (isAMP) { ;
__p += '\n      <p class="italic f13" data-i18n="editor.ampEditTextDisclaimer"></p>\n    ';
 } ;
__p += '\n\n    <div class="ed-modal-footer ed-opt-btnbar">\n      <button\n        type="button"\n        class="btn--ghost e100 js-close"\n        data-dismiss="modal"\n        data-i18n="editor.cancel"\n      ></button>\n      <button\n        type="button"\n        class="ed-btn ed-btn-primary-action js-save e100"\n        data-dismiss="modal"\n        data-i18n="editor.save"\n      ></button>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

